import React, { useContext } from "react";
import { BranchesOutlined } from "@ant-design/icons";
import AppTheme from "../../theme/AppTheme";
import { AppName } from "../../components";
import { authContext } from "../../providers";
import { Spin } from "antd";

const Minimal = (props) => {
  const { auth } = useContext(authContext);
  return (
    <div
      style={{ backgroundColor: AppTheme.colors.background }}
      className="w-screen h-screen absolute flex items-center justify-center overflow-auto"
    >
      <div className="text-center flex-grow">
        <div className="inline-block p-4 w-full sm:w-auto sm:p-0">
          <BranchesOutlined
            className="font-bold"
            style={{ fontSize: "32px", color: AppTheme.colors.primary }}
          />
          <AppName className="text-xl pb-2 block" />
          <Spin spinning={auth.loading} className="w-screen h-screen">
            {props.children}
          </Spin>
        </div>
      </div>
    </div>
  );
};

export default Minimal;
